/** Первая контент-секция (текстура + бегущая строка). */
export const originalPlusFirstSection = {
  id: 'kuratorskiy-otbor',
  label: 'Кураторский отбор',
  heading: 'Curatorial Selection',
} as const;

/** Секции после первой. */
export const originalPlusFollowingSections = [
  { id: 'rost-avtora', label: 'Упаковка автора и продвижение', heading: 'Author Growth' },
  { id: 'sborniki', label: 'Участие в сборниках', heading: 'Anthologies' },
  { id: 'media', label: 'Медиа и спецпроекты', heading: 'Media' },
  { id: 'distribuciya', label: 'Дистрибуция', heading: 'Distribution' },
  { id: 'proekty', label: 'Движение к индустрии', heading: 'Projects' },
] as const;

/** Все якоря для навигации в hero. */
export const originalPlusNavSections = [
  originalPlusFirstSection,
  ...originalPlusFollowingSections,
] as const;

export type OriginalPlusSection =
  | typeof originalPlusFirstSection
  | (typeof originalPlusFollowingSections)[number];

export const sectionTextureContinuedSections = originalPlusFollowingSections;

export const originalPlusStatusSectionId = originalPlusFollowingSections[3].id;

export const originalPlusPlatformHappeningSectionId = originalPlusFollowingSections[4].id;

/** Секции вне текстурной зоны (сейчас не используются). */
export const sectionTexturePlainSections: readonly OriginalPlusSection[] = [];

/** Якорь секции «Частые вопросы». */
export const originalPlusFaqSectionId = 'chastye-voprosy';
